import { render, staticRenderFns } from "./LookupValueInput.vue?vue&type=template&id=0f53bef7"
import script from "./LookupValueInput.vue?vue&type=script&lang=js"
export * from "./LookupValueInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports